var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 530,
    viewBox: "0 0 559 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.842,
    width: 411.895,
    height: 29.4211,
    fill: "#CE7C35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.842,
    y: 500.158,
    width: 411.895,
    height: 29.4211,
    fill: "#CE7C35"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 500.158,
    y: 58.8421,
    width: 29.4211,
    height: 411.895,
    fill: "#CE7C35"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 58.8421,
    width: 29.4211,
    height: 411.895,
    fill: "#CE7C35"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.421,
    y: 29.421,
    width: 29.4211,
    height: 29.4211,
    fill: "#CE7C35"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 470.737,
    y: 29.421,
    width: 29.4211,
    height: 29.4211,
    fill: "#CE7C35"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 470.737,
    y: 470.737,
    width: 29.4211,
    height: 29.4211,
    fill: "#CE7C35"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.421,
    y: 470.737,
    width: 29.4211,
    height: 29.4211,
    fill: "#CE7C35"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 529.579,
    y: 58.8421,
    width: 29.4211,
    height: 411.895,
    fill: "#E2A93F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 500.158,
    y: 29.421,
    width: 29.4211,
    height: 29.4211,
    fill: "#E2A93F"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 470.737,
    width: 29.4211,
    height: 29.4211,
    fill: "#E2A93F"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 500.158,
    y: 470.737,
    width: 29.4211,
    height: 29.4211,
    fill: "#E2A93F"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 470.737,
    y: 500.158,
    width: 29.4211,
    height: 29.4211,
    fill: "#E2A93F"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 29.421,
    y: 58.8421,
    width: 470.737,
    height: 411.895,
    fill: "#F7D046"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 58.842,
    y: 29.421,
    width: 411.895,
    height: 470.737,
    fill: "#F7D046"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 353.053,
    y: 353.053,
    width: 117.684,
    height: 117.684,
    fill: "#CE7C35"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 382.474,
    y: 382.474,
    width: 58.8421,
    height: 58.8421,
    fill: "#E2A93F"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 411.895,
    y: 411.895,
    width: 29.4211,
    height: 29.4211,
    fill: "#F7D046"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 205.947,
    y: 353.053,
    width: 117.684,
    height: 117.684,
    fill: "#CE7C35"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 235.368,
    y: 382.474,
    width: 58.8421,
    height: 58.8421,
    fill: "#E2A93F"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 264.789,
    y: 411.895,
    width: 29.4211,
    height: 29.4211,
    fill: "#F7D046"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 58.842,
    y: 353.053,
    width: 117.684,
    height: 117.684,
    fill: "#CE7C35"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 88.2629,
    y: 382.474,
    width: 58.8421,
    height: 58.8421,
    fill: "#E2A93F"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 117.684,
    y: 411.895,
    width: 29.4211,
    height: 29.4211,
    fill: "#F7D046"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 353.053,
    y: 205.947,
    width: 117.684,
    height: 117.684,
    fill: "#CE7C35"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 382.474,
    y: 235.368,
    width: 58.8421,
    height: 58.8421,
    fill: "#E2A93F"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 411.895,
    y: 264.789,
    width: 29.4211,
    height: 29.4211,
    fill: "#F7D046"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 205.947,
    y: 205.947,
    width: 117.684,
    height: 117.684,
    fill: "#CE7C35"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 235.368,
    y: 235.368,
    width: 58.8421,
    height: 58.8421,
    fill: "#E2A93F"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 264.789,
    y: 264.789,
    width: 29.4211,
    height: 29.4211,
    fill: "#F7D046"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 58.842,
    y: 205.947,
    width: 117.684,
    height: 117.684,
    fill: "#CE7C35"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 88.2629,
    y: 235.368,
    width: 58.8421,
    height: 58.8421,
    fill: "#E2A93F"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 117.684,
    y: 264.789,
    width: 29.4211,
    height: 29.4211,
    fill: "#F7D046"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 353.053,
    y: 58.8421,
    width: 117.684,
    height: 117.684,
    fill: "#CE7C35"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 382.474,
    y: 88.2632,
    width: 58.8421,
    height: 58.8421,
    fill: "#E2A93F"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 411.895,
    y: 117.684,
    width: 29.4211,
    height: 29.4211,
    fill: "#F7D046"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 205.947,
    y: 58.8421,
    width: 117.684,
    height: 117.684,
    fill: "#CE7C35"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 235.368,
    y: 88.2632,
    width: 58.8421,
    height: 58.8421,
    fill: "#E2A93F"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 264.789,
    y: 117.684,
    width: 29.4211,
    height: 29.4211,
    fill: "#F7D046"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 58.842,
    y: 58.8421,
    width: 117.684,
    height: 117.684,
    fill: "#CE7C35"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 88.2629,
    y: 88.2632,
    width: 58.8421,
    height: 58.8421,
    fill: "#E2A93F"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 117.684,
    y: 117.684,
    width: 29.4211,
    height: 29.4211,
    fill: "#F7D046"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 147.105,
    y: 294.21,
    width: 235.368,
    height: 88.2631,
    fill: "#763E30"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 176.526,
    y: 382.474,
    width: 176.526,
    height: 29.4211,
    fill: "#763E30"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 205.947,
    y: 411.895,
    width: 117.684,
    height: 29.4211,
    fill: "#763E30"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 176.526,
    y: 323.632,
    width: 176.526,
    height: 58.8421,
    fill: "#DF809E"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 205.947,
    y: 382.474,
    width: 117.684,
    height: 29.4211,
    fill: "#DF809E"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 323.632,
    y: 205.947,
    width: 88.2631,
    height: 58.8421,
    fill: "#763E30"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 353.053,
    y: 176.526,
    width: 58.8421,
    height: 29.4211,
    fill: "#763E30"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 117.684,
    y: 205.947,
    width: 88.2631,
    height: 58.8421,
    fill: "#763E30"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 147.105,
    y: 176.526,
    width: 58.8421,
    height: 29.4211,
    fill: "#763E30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ccc0afbdc796477bea86b4066b994756.svg";
export { ForwardRef as ReactComponent };